import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Llevaba 3 años tomando ibuprofeno todas las mañanas. En el día 4 del protocolo me di cuenta que no lo había necesitado. Lloré de la emoción.',
    name: 'Carmen R.',
    age: '67 años',
    location: 'Ciudad de México'
  }, {
    quote: 'Mi médico me dijo que era desgaste normal. Decidí intentar esto de todas formas. Después de 7 días le mostré mis rodillas a mi hija y las dos nos sorprendimos. La hinchazón había bajado notablemente.',
    name: 'Patricia M.',
    age: '71 años',
    location: 'Bogotá'
  }, {
    quote: 'Lo que más me impresionó fue entender POR QUÉ me dolía. Nadie me había explicado la conexión entre el intestino y las articulaciones. Ahora lo entiendo y sé exactamente qué hacer.',
    name: 'Rosa Elena V.',
    age: '64 años',
    location: 'Miami'
  }, {
    quote: 'Gasté más de $200 dólares al mes durante 2 años en suplementos. Este protocolo me cuesta $12 a la semana y funciona mejor que todo lo que probé antes.',
    name: 'Miriam T.',
    age: '69 años',
    location: 'Buenos Aires'
  }];
  return <section className="bg-white py-16 px-6 md:px-12 lg:px-24" data-id="element-246">
      <div className="max-w-6xl mx-auto" data-id="element-247">
        <FadeIn data-id="element-248">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-text-black mb-16" data-id="element-249">
            Lo que dicen las mujeres que ya lo probaron:
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-250">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-251">
              <div className="bg-cream p-8 rounded-2xl shadow-sm border border-gold-light h-full flex flex-col" data-id="element-252">
                <div className="flex gap-1 mb-6" data-id="element-253">
                  {[...Array(5)].map((_, i) => <Star key={i} className="text-gold fill-gold" size={20} data-id="element-254" />)}
                </div>
                <p className="text-xl text-text-black italic mb-8 flex-grow" data-id="element-255">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center gap-4" data-id="element-256">
                  <div className="w-12 h-12 bg-sage-light rounded-full flex items-center justify-center text-dark-green font-serif font-bold text-xl" data-id="element-257">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div data-id="element-258">
                    <p className="font-bold text-text-black" data-id="element-259">
                      {testimonial.name}, {testimonial.age}
                    </p>
                    <p className="text-text-gray text-sm" data-id="element-260">
                      {testimonial.location}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}